export default "__VITE_ASSET__Yvy2jpXc__"